import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";


const getById = (id) => {
    const params = {
      id,
    };
    return axiosGet(
      appsettings.ocpbComplaintAPIUrl + "api/User/GetById",
      params
    );
  };

  const searchDigitalId = (params) => {
    
    return axiosGet(
      appsettings.digtalIdAPIUrl + "api/User/Search",
      params
    );
  };

  const searchUserInspect = (params) => {
    
    return axiosGet(
      appsettings.digtalIdAPIUrl + "api/customer/search",
      params
    );
  };

  const urlAuthorizeByOfficer = () => {   

    // return axiosGet(
    //   appsettings.digtalIdAPIUrl + "api/oauth/authorizeByOfficer"+
    //   params
    // );
    return appsettings.digtalIdOauthUrl + "oauth/authorizeByOfficer";
  };

export {
    getById,
    searchDigitalId,
    searchUserInspect,
    urlAuthorizeByOfficer,
};
